const headers = {
  name: "Salesman",
  navigate: {
    path: [
      {
        name: "Salesman",
        path: "/app/salesman",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
